<div class="container-full bg-theme">
  <div class="container">
    <div class="columns">
      <div class="column is-12 p-b-xl">
        <div
          class="temporary-item temporary-breadcrumbs"
          *ngIf="!breadcrumbLinks"
        ></div>
        <app-breadcrumbs
          [darkTheme]="true"
          [breadcrumbLinks]="breadcrumbLinks"
        ></app-breadcrumbs>
        <span class="title is-1 has-text-light" i18n="@@toolsTitle">
          Catalogue of Tools & Metrics for Trustworthy AI
        </span>
        <p i18n="@@toolsBlurb" class="has-text-light m-y-gutter">
          These tools and metrics are designed to help AI actors develop and use
          trustworthy AI systems and applications that respect human rights and
          are fair, transparent, explainable, robust, secure and safe.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="container-full">
  <div class="subnav has-background-white">
    <div class="container">
      <div class="columns">
        <div class="column is-12 p-y-4">
          <div class="level is-mobile full-width subnav--level">
            <div class="level-left">
              <div class="level-item">
                <a
                  class="button is-small is-white"
                  routerLink="/catalogue/overview"
                  routerLinkActive="is-active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  >Overview</a
                >
                <a
                  class="button is-small is-white"
                  routerLink="/catalogue/tools"
                  [ngClass]="{ 'is-active': isToolsSection }"
                  >Tools</a
                >

                <a
                  class="button is-small is-white"
                  routerLink="/catalogue/metrics"
                  [ngClass]="{ 'is-active': isMetricsSection }"
                  >Metrics</a
                >

                <a
                  class="button is-small is-white"
                  routerLink="/catalogue/faq"
                  routerLinkActive="is-active"
                  >About the catalogue</a
                >
              </div>
            </div>
            <div class="level-right is-hidden-mobile">
              <div class="dropdown is-active is-right">
                <div class="dropdown-trigger">
                  <a
                    class="button is-warning has-text-weight-bold"
                    routerLink="/catalogue/contribute"
                    >Contribute to the catalogue</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container m-t-alt is-hidden-tablet">
  <div class="columns">
    <div class="column has-text-right pb-0">
      <div class="dropdown is-active is-right">
        <div class="dropdown-trigger">
          <a
            class="button is-warning has-text-weight-bold"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            routerLink="/catalogue/contribute"
          >
            <span>Contribute to the catalogue</span>
            <span class="icon is-small">
              <i class="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
